/* --- Dependencies --- */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { updateProfile } from "../../../../domain/profile/profileActions";
import ProfileEditForm from "../../../forms/secure/profile/ProfileEditForm/ProfileEditForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import styles from "./ProfileEdit.module.less";
import track from "react-tracking";
class ProfileEdit extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        let profileFormTemplate;
        const { profile } = this.props;
        if (profile) {
            profileFormTemplate = (<ProfileEditForm fieldErrors={this.props.profileFieldErrors} profile={profile} updateProfile={this.props.updateProfile} isLoading={this.props.profileIsLoading}/>);
        }
        else {
            profileFormTemplate = (<div className="text">
					<p className="error">
						<FormattedMessage id="profileEdit.notLoaded" defaultMessage="Your profile information wasn't loaded. Logout and try again."/>
					</p>
				</div>);
        }
        return (<div className={styles.wrapper}>
				<div className="vr vr_x4">
					<h1 className="hdg js-pageHeader">
						<FormattedMessage id="profileEdit.header" defaultMessage="Edit My Personal Information"/>
					</h1>
				</div>
				<StatusMessage isError isActive={this.props.profileError ? true : false} error={this.props.profileError ? this.props.profileError : null} customMessage={StatusMessages.PROFILE.EDIT_ERROR_INTRO} domain="profile"/>
				<StatusMessage isError={!this.props.profileIsSuccess} isSuccess={this.props.profileIsSuccess} isActive={this.props.profileIsSuccess !== null ? true : false} customMessage={this.props.profileIsSuccess ?
            StatusMessages.PROFILE.SUCCESS_MESSAGE_PROFILE :
            ""} domain="profile"/>
				<div className="vr vr_x5">
					<div className="text">
						<FormattedMessage tagName="p" id="profileEdit.changePassword" defaultMessage="To change your password {link}" values={{
            link: (<Link className="link" to="/secured/changePassword">
										<FormattedMessage id="profileEdit.changePassword.link" defaultMessage="click here. {srOnly}" values={{
                srOnly: (<span className="u-isVisuallyHidden">
														<FormattedMessage id="profileEdit.changePassword.link.srOnly" defaultMessage="(to change your password)"/>
													</span>)
            }}/>
									</Link>)
        }}/>
					</div>
				</div>

				<div className="vr vr_x4">
					{profileFormTemplate}
				</div>

				<StatusMessage isLoad isActive={this.props.profileIsLoading ? true : false}/>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    profile: state.profile.profile,
    profileError: state.profile.error,
    profileFieldErrors: state.profile.fieldErrors,
    profileIsLoading: state.profile.isLoading,
    profileIsSuccess: state.profile.isSuccess,
    loggedIn: state.auth.loggedIn
});
const bindActionsToProps = {
    updateProfile
};
/* Create and export container component that wraps ProfileEdit for property binding */
export default track({ page: "ProfileEdit" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(ProfileEdit));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/ProfileEdit/ProfileEdit.tsx